export default __webpack_public_path__ + "static/media/idealProtect.cbd14f7b.jpg";